import React from 'react';

import { Svg, type SvgProps } from './svg';

export function UsersMultipleIcon(props: SvgProps) {
  return (
    <Svg data-testid="users-multiple-icon" {...props}>
      <path d="M12 5.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7ZM5 8c.56 0 1.08.15 1.53.42a5.54 5.54 0 0 0 1.13 3.96A3 3 0 1 1 5 8Zm14 0a3 3 0 1 1-2.66 4.38 5.54 5.54 0 0 0 1.13-3.96c.45-.27.97-.42 1.53-.42ZM5.5 18.25c0-2.07 2.91-3.75 6.5-3.75s6.5 1.68 6.5 3.75V20h-13v-1.75ZM0 20v-1.5c0-1.39 1.89-2.56 4.45-2.9a4.04 4.04 0 0 0-.95 2.65V20H0Zm24 0h-3.5v-1.75c0-1.03-.36-1.97-.95-2.65 2.56.34 4.45 1.51 4.45 2.9V20Z" />
    </Svg>
  );
}
